import script from "./ThePageContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./ThePageContainer.vue?vue&type=script&lang=ts&setup=true"

import "./ThePageContainer.vue?vue&type=style&index=0&id=11b3a588&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11b3a588"]])

export default __exports__